export default {
  toasts: {
    printing: 'Bezig met afdrukken...',
    print_failed: 'Afdrukken mislukt. Probeer opnieuw',
    orders: {
      print_one: 'Bezig {{count}} bon af te drukken: Bestelling <strong>#{{orderNumber}}</strong>...',
      print_other: 'Bezig {{count}} bonnen af te drukken: Bestelling <strong>#{{orderNumber}}</strong>...',
    },
  },
};
